import React, { useState, useEffect, Fragment } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../HandleHttpErrors";
import { Row, Col, Table, Spinner } from "react-bootstrap";
import Edit from "./Edit";
import ErrorModal from "../ErrorModal";
import GetMemberName from "./GetMemberName";
import GetRole from "./GetRole";
import SendConformationModal from "../shared/SendConformationModal";

const baseURL = process.env.REACT_APP_API_JOBS;

const Listdelete = ({
  increment,
  counter,
  setCounter,
  meeting_id,
  roles,
  members,
}) => {
  const [bhinaMembers, setBhinaMembers] = useState(null);
  const [sendTo, setSendTo] = useState([]);
  const [recId, setRecId] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [errorHeader, setErrorHeader] = useState("");
  const [displaySendConfirmationModal, setDisplaySendConfirmationModal] =
    useState(false);
  const [isSending, setIsSending] = useState(false);
  const [loading, setLoading] = useState(true);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.get(
          baseURL + "bhinamember?meeting_id=" + meeting_id,
          {
            signal: controller.signal,
          }
        );
        isMounted && setBhinaMembers(response.data);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
      setLoading(false);
    };

    getData();
  }, [counter]);

  const handleEditClick = (event, Rec) => {
    event.preventDefault();
    setRecId(Rec.id);
  };
  const handleCancelClick = () => {
    setRecId(null);
  };
  const showSendModal = (event) => {
    setDisplaySendConfirmationModal(true);
  };

  // Hide the modal
  const hideConfirmationModal = () => {
    setIsSending(false);
    setDisplaySendConfirmationModal(false);
  };
  const sendEmails = async (htmlMessage) => {
    setLoading(true);
    const getData = async () => {
      let isMounted = true;
      const controller = new AbortController();
      try {
        const response = await axiosPrivate.post(
          baseURL + "bhinamembersendemails/",
          {
            subject: "",
            message: "",
            htmlmessage: htmlMessage,
            meeting_id: meeting_id,
            to: sendTo + " ",
          },

          {
            signal: controller.signal,
          }
        );
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
      setLoading(false);
    };

    getData();

    setIsSending(false);
    hideConfirmationModal();
  };

  if (!bhinaMembers) return null;
  if (loading) {
    // Render a spinner while the data is loading
    return (
      <div className="d-flex justify-content-center align-items-center">
        <div className="text-center">
          <Spinner animation="border" variant="danger" visible />
          <br />
          <h3 className="spinnerText">המתן עד סיום הפעולה.</h3>
          <br />
          <h4 className="spinnerText">
            נא זכור לבדוק את תיבת המייל של השולח -של המשתמש- על מנת לוודא
            שהמיילים אכן נשלחו.
          </h4>
        </div>
      </div>
    );
  } else {
    return (
      <>
        <SendConformationModal
          showModal={displaySendConfirmationModal}
          confirmModal={sendEmails}
          hideModal={hideConfirmationModal}
          isSending={isSending}
          setIsSending={setIsSending}
        />

        <div className="mx-auto">
          <Row>
            <Col sm="10" md={{ size: 3, offset: 1 }}>
              <form onSubmit={increment}>
                <Table hover>
                  <thead>
                    <tr>
                      <th>
                        {" "}
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={(event) => showSendModal(event)}
                        >
                          שליחת הזמנה
                        </button>
                      </th>

                      <th>שם</th>
                      <th>תפקיד</th>
                      <th>תאריך הזמנה</th>
                      <th>השתתף?</th>
                      <th>הערות</th>
                    </tr>
                  </thead>
                  <tbody>
                    {bhinaMembers?.map((rec) => (
                      <Fragment key={rec.id}>
                        {recId === rec.id ? (
                          <Edit
                            rec={rec}
                            handleCancelClick={handleCancelClick}
                            increment={increment}
                            counter={counter}
                            setRecId={setRecId}
                            members={members}
                            roles={roles}
                          />
                        ) : (
                          <ReadOnlyRows
                            rec={rec}
                            handleEditClick={handleEditClick}
                            increment={increment}
                            setRecId={setRecId}
                            setShowError={setShowError}
                            setErrorMessage={setErrorMessage}
                            setErrorHeader={setErrorHeader}
                            members={members}
                            roles={roles}
                            setSendTo={setSendTo}
                            setTo={sendTo}
                          />
                        )}
                      </Fragment>
                    ))}
                  </tbody>
                </Table>
              </form>
            </Col>
          </Row>
        </div>

        <ErrorModal
          showError={showError}
          setShowError={setShowError}
          errorMessage={errorMessage}
          errorHeader={errorHeader}
        />
      </>
    );
  }
};
export default Listdelete;

const ReadOnlyRows = ({
  rec,
  handleEditClick,
  setRecId,
  increment,
  setShowError,
  setErrorMessage,
  setErrorHeader,
  members,
  roles,
  setSendTo,
  sendTo,
}) => {
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  const handleDelete = (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const deletePost = async () => {
      try {
        const response = await axiosPrivate.delete(
          baseURL + "bhinamember/" + rec.id,
          {
            signal: controller.signal,
          }
        );
        isMounted && increment();
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    deletePost();

    setRecId(null);
  };

  const handleSendTo = async (e) => {
    e.preventDefault(); // prevent the default action
    const checkValue = e.target.checked;
    const index = e.target.value;
    if (e.target.checked) {
      setSendTo((prevState) => [...prevState, e.target.value]);
    } else {
      setSendTo((prevState) =>
        prevState.filter((prevItem) => prevItem.id !== e.target.value)
      );
    }
  };

  return (
    <>
      <tr>
        <td>
          <input
            type="checkbox"
            id="sendEmail"
            name="sendEmail"
            value={rec.memberlist}
            onChange={handleSendTo}
          />
        </td>
        <td>
          <GetMemberName members={members} memId={rec.memberlist} />
        </td>
        <td>
          <GetRole roles={roles} roleId={rec.role} />
        </td>
        <td>{rec.send_date}</td>
        <td>
          <input
            readOnly
            type="checkbox"
            id="attend"
            name="attend"
            checked={rec.attend}
          />
        </td>
        <td>{rec.notes} </td>

        <td>
          <button
            type="button"
            className="btn btn-success"
            onClick={(event) => handleEditClick(event, rec)}
          >
            <FiEdit2 />
          </button>
          <span> </span>

          <button
            type="button"
            className="btn btn-danger"
            onClick={handleDelete}
          >
            <FiTrash2 />
          </button>
        </td>
      </tr>
    </>
  );
};
